import { Component } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { FieldTypeConfig } from '@ngx-formly/core'
import { FieldType } from '@ngx-formly/material'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'

@Component({
		selector: 'gwc-masked-input',
		templateUrl: './masked.input.component.html',
		styleUrls: ['./masked.input.component.scss'],
		imports: [
			MatInputModule,
			ReactiveFormsModule,
			NgxMaskDirective
		],
		providers: [
			provideNgxMask()
		]
})

export class MaskedInputComponent extends FieldType<FieldTypeConfig> {
}
